import Splide from "@splidejs/splide";
// Default theme
import "@splidejs/splide/css";

// or only core styles
import "@splidejs/splide/css/core";

export default function () {
  const splideElements = document.querySelectorAll(".splide:not(.splide--2)");
  const splideElements2 = document.querySelectorAll(".splide.splide--2");

  if (splideElements.length) {
    const options = {
      perPage: 3,
      perMove: 1,
      // rewind: true,
      arrows: true,
      pagination: false,
      // lazyLoad: "nearby",
      gap: "4rem",
      // trimSpace: "move",

      breakpoints: {
        1000: {
          perPage: 2,
        },

        680: {
          perPage: 1,
        },
      },
    };
    const splide = new Splide(".splide", options);
    splide.mount();
  }

  if (splideElements2.length) {
    const options2 = {
      perPage: 4,
      perMove: 1,
      // rewind: true,
      arrows: true,
      pagination: false,
      // lazyLoad: "nearby",
      gap: "4rem",
      // trimSpace: "move",

      breakpoints: {
        1000: {
          perPage: 3,
        },

        680: {
          perPage: 2,
        },
        500: {
          perPage: 1,
        },
      },
    };
    const splide2 = new Splide(".splide", options2);
    splide2.mount();
  }
}
